import {Component} from '@angular/core';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-balans-activa',
  templateUrl: './tekst-balans-activa.component.html',
  styleUrls: ['./tekst-balans-activa.component.scss'],
})
export class TekstBalansActivaComponent {}
